export const IMAGE_URL =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://ws.maritima.fr/api/" : "https://staging.ws.maritima.fr/api/";
export const IMAGE_URL_WYSIWYG =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://ws.maritima.fr/api/" : "https://staging.ws.maritima.fr/api/";
export const API_URL =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://ws.maritima.fr/api_bo/" : "https://staging.ws.maritima.fr/api_bo/";
export const MARITIMMA_NEWSLETTER =
  process.env.REACT_APP_NODE_ENV === "production"
    ? "https://maritima.fr/" : "https://staging.web.maritima.fr/";
